import {MonoTypeOperatorFunction, Observable} from 'rxjs';
import {mapTo, switchMap} from 'rxjs/operators';

// Like debounce but doesn't emit value on stream complete
export function debounceWithoutComplete<T>(selector: (value: T) => Observable<any>): MonoTypeOperatorFunction<T> {
  return switchMap((value: T) => {
    return selector(value).pipe(mapTo(value));
  });
}
